import { render, staticRenderFns } from "./ConfiguracoesMain.vue?vue&type=template&id=5aa7b312&"
import script from "./ConfiguracoesMain.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports